import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
} from 'react-icons/fa';
import { IoIosMail } from 'react-icons/io';
import { IoCall } from 'react-icons/io5';
import whiteLogo from '../../assets/images/home_screen/white_Logo_1_1.png';
import privacyPractices from '../../assets/documents/privacy_practices.pdf';

const Footer = () => {
  const socialLinks = [
    {
      href: 'https://www.facebook.com/people/Guidepost-Pediatric-Therapies-and-Educational-Services/100069076216707/#',
      icon: FaFacebookF,
    },
    { href: 'mailto:guidepostpediatrics@gmail.com', icon: IoIosMail },
    {
      href: 'https://www.instagram.com/guidepostpediatrics',
      icon: FaInstagram,
    },
    {
      href: 'https://www.linkedin.com/company/guidepost-pediatric/about/',
      icon: FaLinkedin,
    },
    { href: 'tel:+19073764880', icon: IoCall },
    { href: 'https://www.youtube.com/@GuidepostPediatric', icon: FaYoutube },
  ];

  const navLinks1 = [
    { href: '/', label: 'Home' },
    { href: '/services', label: 'Our Services' },
    { href: '/our-team', label: 'Staff' },
    { href: '/resources', label: 'Resources' },
  ];

  const navLinks2 = [
    { href: '/appointment', label: 'Your Appointment' },
    { href: '/', label: 'Privacy Policy' },
    { href: '/contact', label: 'Contact Us' },
  ];

  return (
    <div className="bg-[#4D535C] text-white tracking-wide">
      <footer className="container mx-auto px-4 md:px-6 lg:px-20 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          <div className="flex flex-col items-start gap-6">
            <img
              src={whiteLogo}
              alt="Guidepost Pediatric LLC"
              className="w-[210px] object-contain"
            />
            <h2 className="text-lg font-light">
              Guidepost Pediatric Therapies and <br /> Educational Services
            </h2>
            <h2 className="text-lg font-light">
              1174 N Leatherleaf Loop Unit D<br />
              Wasilla, AK 99654
            </h2>
          </div>
          <div className="relative md:top-[48px]">
            <h2 className="text-2xl font-bold mb-2">Hours of Operation</h2>
            <div className="space-y-2">
              <p>Monday-Thursday 7am-7pm</p>
              <p>Friday 9am-5pm</p>
            </div>
            <h2 className="text-2xl font-bold mt-8 mb-2">Quick Links</h2>
            <div className="space-y-2">
              <div className="flex flex-wrap gap-x-2">
                {navLinks1.map((link, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <a href={link.href} className="hover:text-gray-300">
                      {link.label}
                    </a>
                    {index !== navLinks1.length - 1 && <span>|</span>}
                  </div>
                ))}
              </div>

              <div className="flex flex-wrap gap-x-2">
                {navLinks2.map((link, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    {link.label === 'Privacy Policy' ? (
                      <a
                        href="/"
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(privacyPractices, '_blank');
                        }}
                        className="hover:text-gray-300"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <a href={link.href} className="hover:text-gray-300">
                        {link.label}
                      </a>
                    )}
                    {index !== navLinks2.length - 1 && <span>|</span>}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div>
            <div className="space-y-2">
              <div className="flex items-center gap-1 text-xl">
                <span className="font-semibold cursor-pointer">Phone:</span>
                <a href="tel:+19073764880">907-376-4880</a>
              </div>
              <div className="flex items-center gap-1 text-xl">
                <span className="font-semibold">Fax:</span>
                <span>907-376-4885</span>
              </div>
            </div>

            <div className="flex gap-4 mt-8">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                  className="w-7 h-7 flex items-center justify-center bg-white text-black rounded-full hover:bg-gray-200 transition"
                >
                  <link.icon size={16} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-10 border-t border-gray-600 text-center text-sm font-extralight">
          <p>
            © 2025 Guidepost Pediatric Therapies and Educational Services, All
            Rights Reserved.&nbsp;&nbsp;|&nbsp;&nbsp;
            <a href="/" className="hover:text-gray-300">
              Sitemap
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
